import { type FC } from 'react'

import { DirectContactFormImageUploadField } from '../DirectContactFormImageUploadField/DirectContactFormImageUploadField'

import { DirectContactFormCopaymentExemptionNotification } from './DirectContactFormCopaymentExemptionNotification'

export const DirectContactFormCopaymentExemption: FC<{
  isCopaymentExemption: boolean
  isLoggedIn: boolean
}> = ({ isCopaymentExemption, isLoggedIn }) => {
  if (!isCopaymentExemption) {
    return null
  }

  return (
    <>
      <DirectContactFormCopaymentExemptionNotification
        isLoggedIn={isLoggedIn}
      />
      {isLoggedIn ? <DirectContactFormImageUploadField isMandatory /> : null}
    </>
  )
}
